import { useState } from 'react';
import classNames from 'classnames';

import { EColorVariablesV2 } from '@/types/theme-packs.types';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import ProjectColorIcon from '@ui/icons/icon/project-color-icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import { useAppSelector } from '@/store/hooks';
import styles from '../../widget.module.css';
import PublishSettingsModal from './publish-settings-modal';
import { ChannelFeaturesEnum } from '@/types/feature-flags.types';
import useCanUseChannelFeature from '@/utils/use-can-use-channel-features';
import { selectDmaId } from '@/store/slices/settings/selectors';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

const ProductIdWidget = () => {
  const dmaId = useAppSelector(selectDmaId);
  const [open, setOpen] = useState(false);

  const productIdEnabled = useCanUseChannelFeature(ChannelFeaturesEnum.dma_law);

  const toggleModal = () => setOpen((prevState) => !prevState);

  return (
    <div
      className={classNames(styles['widget'], {
        [styles['isDisabled']]: !productIdEnabled,
      })}
    >
      <Container
        background="var(--gray-900)"
        height="56px"
        borderRadius="8px"
        className="flex ai-center jc-space-between padding-16"
      >
        <Text className="H6">Product ID (DMA)</Text>
        {dmaId ? (
          <Container padding="8px 12px" borderRadius="100px" background="var(--gray-700)">
            <Text className="C1" design="GlobalIcoText1" clamp={1} maxWidth="475px">
              {dmaId}
            </Text>
          </Container>
        ) : (
          <Button
            onClick={toggleModal}
            backgroundColor="var(--gray-700)"
            hoverBackgroundColor="var(--gray-1000)"
            className={`${styles['add-button']} flex ai-center gap-6`}
            height="32px"
            opacity={1}
          >
            <ProjectColorIcon name={ICONS.ADD} size={12} colorVariable={EColorVariablesV2.primary} />
            <Text color={getThemeColorCSSVariable()} className="L2">
              Add
            </Text>
          </Button>
        )}
      </Container>
      <PublishSettingsModal open={open} handleClose={toggleModal} dmaId={dmaId || ''} />
    </div>
  );
};

export default ProductIdWidget;
